import React, {useEffect, useState} from "react";
import useStyles from './styles'
import {Button, Paper, TextField, Typography} from "@material-ui/core";
import FileBase from 'react-file-base64'
import {useDispatch} from "react-redux";
import {createPost, updatePost} from "../../actions/posts";
import {useSelector} from "react-redux";

export const Form = ({currentId, setCurrentId}) => {
    const classes = useStyles();
    const [postData, setPostsData] = useState({
        creator: '',
        title: '',
        message: '',
        tags: '',
        selectedFile: ''
    })
    const post = useSelector((state) => currentId ? state.posts.find((p) => p._id === currentId) : null)
    const dispatch = useDispatch();

    useEffect(() => {
        if (post) {
            setPostsData(post)
        }
    }, [post])

    const handleSubmit = (e) => {
        e.preventDefault();
        if (currentId) {
            dispatch(updatePost(currentId, postData))
        } else {
            dispatch(createPost(postData))
        }
        clear()
    }

    const clear = () => {
        setCurrentId(null)
        setPostsData({
            creator: '',
            title: '',
            message: '',
            tags: '',
            selectedFile: ''
        })
    }

    return (
        <Paper className={classes.paper}>
            <form autoComplete={"off"} noValidate className={`${classes.root} ${classes.form}`} onSubmit={handleSubmit}>
                <Typography variant={"h6"}>{currentId ? "Editing" : "Creating"} a memory</Typography>
                <TextField
                    name={"creator"}
                    variant={"outlined"}
                    label={"Creator"}
                    fullWidth
                    value={postData.creator}
                    onChange={(e) => setPostsData({...postData, creator: e.target.value})}
                />
                <TextField
                    name={"title"}
                    variant={"outlined"}
                    label={"Title"}
                    fullWidth
                    value={postData.title}
                    onChange={(e) => setPostsData({...postData, title: e.target.value})}
                />
                <TextField
                    name={"message"}
                    variant={"outlined"}
                    label={"Message"}
                    fullWidth
                    value={postData.message}
                    onChange={(e) => setPostsData({...postData, message: e.target.value})}
                />
                <TextField
                    name={"tags"}
                    variant={"outlined"}
                    label={"Tags"}
                    fullWidth
                    value={postData.tags}
                    onChange={(e) => setPostsData({...postData, tags: e.target.value.split(',')})}
                />
                <div className={classes.fileInput}>
                    <FileBase
                        type="file"
                        multiple={false}
                        onDone={({base64}) => setPostsData({...postData, selectedFile: base64})}
                    />
                </div>
                <Button
                    className={classes.buttonSubmit}
                    variant={"contained"}
                    color={"primary"}
                    size={"large"}
                    type={"submit"}
                    fullWidth
                >
                    Submit
                </Button>
                <Button
                    variant={"contained"}
                    color={"secondary"}
                    size={"small"}
                    fullWidth
                    onClick={clear}
                >
                    Clear
                </Button>
            </form>
        </Paper>
    )
}

export default Form
